import Vue from "vue";
// api: https://github.com/alfhen/vue-cookie
import VueCookie from 'vue-cookie'

Vue.use(VueCookie)
